import React from 'react';

export default function StatCard({
  title = "",
  value = 0,
  trend = "",
  icon = null,
  color = "blue",
  darkMode = false
}) {

  const colorMap = {
    blue: 'text-blue-500 bg-blue-500/10 border-blue-500/20',
    red: 'text-red-500 bg-red-500/10 border-red-500/20',
    green: 'text-green-500 bg-green-500/10 border-green-500/20',
    orange: 'text-orange-500 bg-orange-500/10 border-orange-500/20'
  };

  const trendColor =
    trend?.includes('+')
      ? 'text-green-500 bg-green-500/10'
      : trend?.includes('-')
      ? 'text-red-500 bg-red-500/10'
      : 'text-gray-500 bg-gray-500/10';

  return (
    <div
      className={`p-5 rounded-2xl border relative overflow-hidden transition-all duration-300 ${
        darkMode
          ? 'bg-[#161922] border-gray-800/50'
          : 'bg-white border-gray-200 shadow-sm'
      }`}
    >
      <div className="flex justify-between items-start mb-4">
        <div
          className={`w-9 h-9 rounded-xl flex items-center justify-center border ${
            colorMap[color] || colorMap.blue
          }`}
        >
          {icon}
        </div>

        {trend && (
          <span
            className={`text-[10px] font-bold px-2 py-0.5 rounded-full ${trendColor}`}
          >
            {trend}
          </span>
        )}
      </div>

      <div>
        <p
          className={`text-[11px] font-bold uppercase tracking-wider ${
            darkMode ? 'text-gray-500' : 'text-gray-400'
          }`}
        >
          {title}
        </p>

        <h3
          className={`text-2xl font-bold mt-0.5 tracking-tight ${
            darkMode ? 'text-white' : 'text-gray-900'
          }`}
        >
          {value}
        </h3>
      </div>
    </div>
  );
}